<template>
  <div class="user-about-cont">
    <div class="user-about max-width-box">
      <div class="about-cont-li">
        <div class="about-cont-title">What is Covey？</div>
        <div class="about-cont-main">
          Covey is a school-specific social commerce marketplace that allows
          students and professionals to offer courses to users in North America.
          The course offering includes ALL KINDS OF extracurricular and hobby
          tutorials -- physical education, arts, gaming, and lifestyle-related
          subject to meet users' specific needs.
        </div>
      </div>
      <div class="about-cont-li">
        <div class="about-cont-title">Our mission：</div>
        <div class="about-cont-main">
          Our mission is to empower people to share knowledge and skills with no
          boundaries.
        </div>
      </div>
      <div class="about-cont-li">
        <div class="about-cont-title">Contact us：</div>
        <div class="about-cont-main">Email：info@coveycampus.com</div>
        <div class="about-cont-main">
          LinkedIn：<a href="https://www.linkedin.com/company/CoveyCampus">
            https://www.linkedin.com/company/CoveyCampus
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.user-about-cont {
  width: 100%;
}
.user-about {
  // width: 100%;
  //   max-width: 1336px;
  // height: vw(625);
  background: #fff;
  margin-top: 60px;
  // text-align: center;
  // border-radius: 24px;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
  padding: 48px;
  box-sizing: border-box;
  .about-cont-title {
    //   text-align: center;
    color: #3b3844;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 36px;
    //   font-family: Montserrat, Gilroy, Roboto, Product Sans, sans-serif;
    line-height: 1.5;
  }
  .about-cont-main {
    color: #3b3844;
    font-size: 1rem;
    //   font-family: Montserrat, Gilroy, Roboto, Product Sans, sans-serif;
    font-weight: 400;
    line-height: 1.5;
    font-size: 18px;
    margin-bottom: 16px;
    a {
      word-break: break-all;
      &:hover {
        color: #f48c06;
      }
    }
  }
}
</style>